<template src="./template.html"></template>

<script>
/* eslint-disable */
import _ from 'lodash';
import InputField from '@/components/elements/inputs/index.vue';
import LogosSVG from "@/assets/images/logosSVG";
import { directive as onClickaway } from 'vue-clickaway';

export default {
  name: 'GlobalSearch',
  components: {
    InputField,
    LogosSVG,
  },
  directives: {
    onClickaway: onClickaway,
  },
  data() {
    return{
      globalSearchTerm: '',
      results: {
        users: [],
        locations: [],
        contacts: [],
        shipments: [],
        pickups: [],
      },
      showDropdown: false,
    };
  },
  created() {
    this.resetState()
  },
  computed: {
    haveResults() {
      return !! (this.results?.contacts?.length > 0 ||
        this.results?.shipments?.length > 0 ||
        this.results?.pickups?.length > 0 ||
        this.results?.locations?.length > 0 ||
        this.results?.users?.length > 0)
    }
  },
  methods: {
    resetState() {
      this.results= {
        users: [],
        locations: [],
        contacts: [],
        shipments: [],
        pickups: [],
      };
      this.showDropdown = false;
      this.globalSearchTerm = '';
    },
    search: _.debounce(function(event) {
      if(event.keyCode == 9) return;
      if (event.keyCode == 38 || event.keyCode == 40) {
        // go trough list arrows
        return;
      }
      if(this.globalSearchTerm != '' && this.globalSearchTerm.length >= 3){
        this.$store.dispatch('GET_GLOBAL_SEARCH', this.globalSearchTerm).then((res) => {
          this.results = res;
          this.showDropdown = true;
        })
      } else {
        this.showDropdown = false;
      }
    }, 500),
    goToContacts(id) {
      this.$router.push(`/contacts/contact/${id}`);
      this.resetState();
    },
    goToShipments(id) {
      this.$router.push(`/view-shipment/${id}`);
      this.resetState();
    },
    goToPickups(id, status) {
      const uri = parseInt(status) > 1 ? 'booked' : 'not-planned';
      this.$router.push(`/pickups/${uri}/${id}`);
      this.resetState();
    },
    goToLocations() {
      this.$router.push('/settings/shipping/locations');
      this.resetState();
    },
    goToUsers(id) {
      this.$router.push(`/user/wall/${id}`);
      this.resetState();
    },
    viewAllSearch(path) {
      const current =  Date.now();
      return this.$router.currentRoute.path === path
        ? this.$router.replace({...this.$router.currentRoute, query: {searchTerm : this.globalSearchTerm, globalSearchKey: current}})
        : this.$router.push({ path: path, query: {searchTerm : this.globalSearchTerm, globalSearchKey: current}})
    }
  },
}
</script>
